import Histogram from '../modules/chart/histogram'
import TemplateBK from '../modules/template_html/bk'
import QuoteList from '../modules/quote_table/quote_list'

declare var MobileSelect;
declare var Swiper;

var data = {
    timer:null,
    quotaConfig: {
        host: '//push2.eastmoney.com',
        unpPath: '/api/qt/ulist.np/get',
        token: 'f057cbcbce2a86e2866ab8877db1d059',
        cPath: '/api/qt/clist/get'
    },
    refresh_time: 10,
    init: function () {
        let self = this
        $('.hq-close').click(function(){
            $('.hq-notice').css('display','none')
        })
        self.loadhkrule()
        // $('.hq-notice').click(function(){
        //     window.location.href = 'http://acttg.eastmoney.com/pub/wap_act_ggds_02_01_01_01_0'
        // })
        self.getData(self.getgangguzhishu(), self.bindSwiperData);
        self.makeBK1();
        self.makeHistogram1();
        self.makeQuoteList1();
        self.makeQuoteList2();
        self.makeQuoteList3();
    },
    getParam:function(name){
        var urlpara = decodeURIComponent(location.search);
        var par = {};
        if (urlpara != "") {
            urlpara = urlpara.substring(1, urlpara.length);
            var para = urlpara.split("&");
            var parname;
            var parvalue;
            for (var i = 0; i < para.length; i++) {
                parname = para[i].substring(0, para[i].indexOf("="));
                parvalue = para[i].substring(para[i].indexOf("=") + 1, para[i].length);
                par[parname] = parvalue;
            }
        }
        if(typeof (par[name]) != "undefined"){
            return par[name];
        }
        else{
            return null;
        }
    },
    loadhkrule:function(){
        let self = this
        let params = decodeURIComponent(window.location.search)?.substring(1)?.split('&')
        if(self.getParam("hkruletip") == '1' && self.getParam("backurl")){
            $("#hk-rule").show()
            $("#hk-rule-layer").show()
            
            $("#wrap-close-icon").on('click',function(){
                self.closeHKRuleTip()
            })
            $("#hk-rule-layer").on('click',function(){
                self.closeHKRuleTip()
            })
            $("#goto-quote").on('click',function(){
                window.location.href = params?.[1].split('=')[1]
            })
        }
    },
    closeHKRuleTip:function(){
        let currentUrl = window.location.origin+window.location.pathname
        $("#hk-rule").hide()
        $("#hk-rule-layer").hide()
        window.history.replaceState({newUrl:currentUrl}, "", currentUrl);
    },
    // 港股指数 Ajax 请求地址
    getgangguzhishu: function () {
        let self = this
        let ids = "100.HSI,100.HSCEI,100.HSAHP";
        let url = self.quotaConfig.host + self.quotaConfig.unpPath
            + "?fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=" + ids
            + "&ut=" + self.quotaConfig.token + "&forcect=1";
        return url
    },
    // Ajax 请求
    getData: function (url, callback) {
        let self = this
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                //-> data: 就是我们从服务器获取的数据，然后执行第四步的bindHTML方法
                callback(data,self)
            }
        })
    },
    // 给 Swiper 绑定数据
    bindSwiperData: function (data,self) {
        if (data.rc == 0) {
            let _class = ''
            let _siwper_html = ''
            data.data.diff.forEach((item, index) => {
                if (index == 0) {
                    _class = 'swiper-slide swiper-slide-active'
                } else if (index == 1) {
                    _class = 'swiper-slide swiper-slide-next'
                } else {
                    _class = 'swiper-slide'
                }
                _siwper_html += `<div class="${_class}">
                            <div class="zs-wrap">
                                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                                    <p>${item.f14}</p>
                                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>${self.numberFix(item.f2,2)}</p>
                                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>
                                        <span>${self.numberFix(item.f4,2)}</span>
                                        <span>${self.dataProcess(item.f3,'%')}</span>
                                    </p>
                                </a>
                            </div>
                        </div>`
            })
            $('#gangguzhishu').html(_siwper_html)
            let swiper = new Swiper('.hk-swiper', {
                direction: 'horizontal',
                slidesPerGroup: 3,
                slidesPerView: 3,
                spaceBetween: 10,
                navigation: {
                    nextEl: '.go-nuxt',
                    prevEl: '.go-pre',
                }
            })
        }
    },
    // Swiper 数据刷新
    refreshSwiperData: function (data,self) {
        let _dom = $('#gangguzhishu').find('.swiper-slide')
        if (data.rc == 0) {
            data.data.diff.forEach((item, index) => {
                _dom[index].innerHTML = `<div class="zs-wrap">
                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                    <p>${item.f14}</p>
                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>${self.numberFix(item.f2,2)}</p>
                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>
                        <span>${self.numberFix(item.f4,2)}</span>
                        <span>${self.dataProcess(item.f3,'%')}</span>
                    </p>
                </a>
            </div>`
            })
        }
    },
    makeQuoteList1: function () {
        let self = this
        let quoteList1 = new QuoteList({
            ele: 'hsgt-list',
            tabconfig: {
                tabitem: [
                    {
                        name: 'ggth',
                        title: '港股通(沪)',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&pn=1&pz=8&fid=f3&po=1&fs=b:DLMK0144&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'ggts',
                        title: '港股通(深)',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&pn=1&pz=8&fid=f3&po=1&fs=b:DLMK0146&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'hgt',
                        title: '沪股通',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&pn=1&pz=8&fid=f3&po=1&fs=b:BK0707&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'sgt',
                        title: '深股通',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&pn=1&pz=8&fid=f3&po=1&fs=b:BK0804&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'ah',
                        title: 'AH股',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&pn=1&pz=8&fid=f3&po=1&fs=b:DLMK0101&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    }
                ]
            },
            refresh: 15
        })

        quoteList1.init()
        return quoteList1
    },
    makeQuoteList2: function () {
        let self = this
        let quoteList1 = new QuoteList({
            ele: 'scbx-list',
            tabconfig: {
                tabitem: [
                    {
                        name: 'zbzf',
                        title: '主板涨幅',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&pn=1&pz=8&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fs=m:128+t:3&fields=f1,f2,f3,f4,f12,f13,f14`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'zbdf',
                        title: '主板跌幅',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&pn=1&pz=8&po=0&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fs=m:128+t:3&fields=f1,f2,f3,f4,f12,f13,f14`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'cybzf',
                        title: '创业板涨幅',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&pn=1&pz=8&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fs=m:128+t:4&fields=f1,f2,f3,f4,f12,f13,f14`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'cybdf',
                        title: '创业板跌幅',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&pn=1&pz=8&po=0&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fs=m:128+t:4&fields=f1,f2,f3,f4,f12,f13,f14`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    }
                ]
            },
            refresh: 15
        })

        quoteList1.init()
        return quoteList1
    },
    makeQuoteList3: function () {
        let self = this
        let quoteList1 = new QuoteList({
            ele: 'rmfl-list',
            tabconfig: {
                tabitem: [
                    {
                        name: 'zmgg',
                        title: '知名港股',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&pn=1&pz=8&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fs=b:DLMK0106&fields=f1,f2,f3,f4,f12,f13,f14`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'hcg',
                        title: '红筹股',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&pn=1&pz=8&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fs=b:DLMK0102&fields=f1,f2,f3,f4,f12,f13,f14`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'gqg',
                        title: '国企股',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&pn=1&pz=8&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fs=b:DLMK0103&fields=f1,f2,f3,f4,f12,f13,f14`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'lcg',
                        title: '蓝筹股',
                        api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&pn=1&pz=8&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fs=b:DLMK0105&fields=f1,f2,f3,f4,f12,f13,f14`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,data.f1)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,data.f1)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    }
                ]
            },
            refresh: 15
        })

        quoteList1.init()
        return quoteList1
    },
    makeBK1: function () {
        let self = this
        let bk1 = new TemplateBK({
            ele: 'hybk',
            api: '//push2.eastmoney.com/api/qt/clist/get?cb=?&fltt=2&invt=2&fs=m:201+t:2&fields=f3,f4,f12,f13,f14,f128,f136&ut=bd1d9ddb04089700cf9c27f6f7426281&np=1&pn=1&pz=3&po=1&fid=f3',
            row: 1,
            col: 3,
            refresh_time:10,
            dataprocess: true,
            data: function (data) {
                return data.data.diff
            },
            dataprocessFun: function (_data) {
                let obj = {
                    html: `<div>
                    <a href='#'>
                      <p>${_data.f14}</p>
                      <p class='${_data.f4>0?'gp-asc':(_data.f4<0?'gp-des':'')}'>${self.dataProcess(_data.f3,'%')}</p>
                      <p>
                          <span>${_data.f128 == null ? '-' : _data.f128}</span>
                          <span  class='${_data.f136>0?'gp-asc':(_data.f136<0?'gp-des':'')}'>${self.dataProcess(_data.f136,'%')}</span>
                      </p>
                    </a>
                  </div>`,
                }
                return obj
            }
        })
        bk1.init()
    },
    makeHistogram1: function () {
        let histogram1 = new Histogram({
            api: '//push2.eastmoney.com/api/qt/multi/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&rt6=fs%3Dm%3A201%2Bt%3A2%26po%3D1&rt6=fs%3Dm%3A201%2Bt%3A2%26po%3D0&np=1&pn=1&pz=3&fid=f62&fields=f12,f13,f14,f62',
            ele: 'hybkjlr',
            refresh_time:10,
            data: function (data) {
                let arr = data.data[0].diff.concat(data.data[1].diff.reverse())
                return arr
            }
        })
        histogram1.init()
    },
    // 页面自刷
    refresh: function () {
        let self = this
        let url = self.getgangguzhishu()
        if (self.refresh_time > 0) {
            clearInterval(self.timer)
            self.timer = setInterval(() => {
                self.getData(url, self.refreshSwiperData)
            }, self.refresh_time * 1000);
        }
    },
    numberFix(num: number, n: number) {
        var f = parseFloat(String(num));
        if (isNaN(f)) {
          return '-';
        }
        var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
        if (n == 0) {
          return f
        } else {
          var s = f.toString();
          var rs = s.indexOf('.');
          if (rs < 0) {
            rs = s.length;
            s += '.';
          }
          while (s.length <= rs + n) {
            s += '0';
          }
          return s;
        }
    },
    dataProcess(data,symbol){
        let self = this
        if(data == undefined || data == null || data == '-'){
            return '-'
        }else{
            return self.numberFix(data,2) + symbol
        }
    }
}

data.init()